import Vue from 'vue';
export default {
    '-1': [
        { value: 0, text: Vue.$trans(`全部协议`) }
    ],
    8: [
        { value: 0, text: 'Echo request' }
    ],
    0: [
        { value: 0, text: 'Echo reply' }
    ],
    3: [
        { value: 0, text: 'Destination network unreachable' },
        { value: 1, text: 'Destination host unreachable' },
        { value: 2, text: 'Destination protocol unreachable' },
        { value: 3, text: 'Destination port unreachable' },
        { value: 4, text: 'Fragmentation required, and DF flag set' },
        { value: 5, text: 'Source route failed' },
        { value: 6, text: 'Destination network unknown' },
        { value: 7, text: 'Destination host unknown' },
        { value: 8, text: 'Source host isolated' },
        { value: 9, text: 'Network administratively prohibited' },
        { value: 10, text: 'Host administratively prohibited' },
        { value: 11, text: 'Network unreachable for TOS' },
        { value: 12, text: 'Host unreachable for TOS' },
        { value: 13, text: 'Communication administratively prohibited' },
        { value: 14, text: 'Host Precedence Violation' },
        { value: 15, text: 'Precedence cutoff in effect' }
    ],
    4: [
        { value: 0, text: 'Source quench (congestion control)' }
    ],
    5: [
        { value: 0, text: 'Redirect Datagram for the Network' },
        { value: 1, text: 'Redirect Datagram for the Host' },
        { value: 2, text: 'Redirect Datagram for the TOS & network' },
        { value: 3, text: 'Redirect Datagram for the TOS & host' }
    ],
    9: [
        { value: 0, text: 'Router Advertisement' }
    ],
    10: [
        { value: 0, text: 'Router discovery/selection/solicitation' }
    ],
    11: [
        { value: 0, text: 'TTL expired in transit' },
        { value: 1, text: 'Fragment reassembly time exceeded' }
    ],
    12: [
        { value: 0, text: 'Pointer indicates the error' },
        { value: 1, text: 'Missing a required option' },
        { value: 2, text: 'Bad length' }
    ],
    13: [
        { value: 0, text: 'Timestamp' }
    ],
    14: [
        { value: 0, text: 'Timestamp reply' }
    ],
    15: [
        { value: 0, text: 'Information request' }
    ],
    16: [
        { value: 0, text: 'Information reply' }
    ],
    17: [
        { value: 0, text: 'Address mask request' }
    ],
    18: [
        { value: 0, text: 'Address mask reply' }
    ],
    30: [
        { value: 0, text: 'Information request' }
    ]
} as any;
